(function($){
    Drupal.behaviors.me1demo = {
        attach() {
            $(once('mo42', 'body')).first().each(function () {

                function openModal($instance) {
                    const $modal = $instance.closest('.MO42').find('.ME1');
                    $modal.openModal();
                }

                function closeModal($instance) {
                    const $modal = $instance.closest('.MO42').find('.ME1');
                    $modal.closeModal();
                }

                $(document).on('click', '.MO42__open-modal', function (event) {
                    openModal($(this));
                });

                $(document).on('click', '.MO48__close', function (event) {
                    closeModal($(this));
                });
            });
        }
    };
})(jQuery);
